import React,{useState,useEffect} from 'react'
import { useLocation } from "react-router-dom";
import { calculateDepreciation } from '../services/asset.service';
import  * as CryptoJS  from "crypto-js";
import ConfirmBox from './ConfirmBox';
function MultiListPopUpBothAsIndAs(props) {
    
    var block = props.showBothAsIndAs? "display-block": "";
    const [validName, setValidName] = useState(true);
    const [errMsgBothAsIndAs, setErrMsgBothAsIndAs] = useState('');
    const [successBothAsIndAs, setSuccessBothAsIndAs] = useState(false);
    const [popupLoadingBothAsIndAs, setPopupLoadingBothAsIndAs] = useState(false);
    const [overwriteDep, setOverwriteDep] = useState('No');
    const [overwriteBtnBothAsIndAs, setOverwriteBtnBothAsIndAs] = useState(false);
    const [financeInfoBothAsIndAs, setFinanceInfoBothAsIndAs] = useState(false);
    const [listOptionsBothAsIndAs, setListDataBothAsIndAs] = useState([]);
    //const [listOptions2, setListData2] = useState([]);
    
    var asset_data_both = [...props.dataBothAsIndAs];
    //console.log('asset_data_both='); console.log(asset_data_both);
    const [foundAssetsBothAsIndAs, setFoundAssetsBothAsIndAs] = useState(asset_data_both);

    
    const filter_both = (e) => { 
        const keyword = e.target.value;
        if (keyword !== '') {
        const results = asset_data_both.filter((asset) => {
            return asset.tag.startsWith(keyword);
        });
        console.log(results);
        setFoundAssetsBothAsIndAs(results);
        } else {
        setFoundAssetsBothAsIndAs(asset_data_both);
        // If the text field is empty, show all users
        }
        setName(keyword);
    };

    const [back_url, setBackUrl] = useState(false);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Finance = query.get('finance'); 
    //const elementRef = useRef();
    useEffect(() => {
        if(Finance!='' && Finance!=null){
            const decryptedBytes = CryptoJS.AES.decrypt(Finance.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
              // Convert the decrypted bytes to a string
              const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
              //const decryptedFinance = decrypt_data.finance;
              setBackUrl(decrypt_data?.back_url);
              setFinanceInfoBothAsIndAs(decrypt_data);
          }
        //setListData2({listOptionsBothAsIndAs});
        //setFoundAssetsBothAsIndAs(asset_data_both);
        setListDataBothAsIndAs(listOptionsBothAsIndAs);
    }, []);
    // check array pushListOptions
    //refrest_ListData1
    const refrest_ListData1 = (e) => {
        setListDataBothAsIndAs(listOptionsBothAsIndAs);
    }
    const pushListOptions=(obj)=>{
        var flag=0;
        setPopupLoadingBothAsIndAs(true);
        listOptionsBothAsIndAs.forEach((elem)=>{
          if(obj.value===elem.value && obj.label===elem.label){
            flag=1;
        }
      });
      setPopupLoadingBothAsIndAs(false);
      if(flag===1){
          return false;
      }else{
          return true;
      }
    };

   //search filter_both 
   // the value of the search field 
  const [name, setName] = useState('');
   // the search result
  //const [foundAssetsBothAsIndAs, setFoundAssetsBothAsIndAs] = useState(asset_data_both);
  //console.log('foundAssetsBothAsIndAs='); console.log(foundAssetsBothAsIndAs);
  
  //start validation   
  const handleSubmit = async (e) => { 
      e.preventDefault(); var valid_Name=true;
        if(financeInfoBothAsIndAs.finance_year ===''){
                setValidName(false);
                alert("Financial year is missing"); valid_Name=false;
        }
        if(financeInfoBothAsIndAs.finance_month ===''){ 
                setValidName(false);
                alert('Month is missing'); valid_Name=false;
        }
        if(listOptionsBothAsIndAs.length===0){ //alert(listOptionsBothAsIndAs.length);
                setValidName(false);
                alert('Please select atleast one Asset'); valid_Name=false;
        }
        if (!valid_Name) { //alert(valid_Name); 
                return false;
        }else{  //alert(mon); alert(fy);
            //    saveData();
                props.setLoadingBothAsIndAs(true); // show loader
            try {
                await saveData();
                // successBothAsIndAs logic here
            } catch (err) {
                console.error("Error saving:", err);
            } finally {
                props.setLoadingBothAsIndAs(false); // hide loader
            }
        }
    }
  const handleOverwriteDep = async (e) => {
    e.preventDefault();
    const overwriteConfirmation = window.confirm("Are you sure you want to Overwrite?");
    //alert(overwriteConfirmation);
    if (overwriteConfirmation) {
        //alert("Confirmed! Proceeding...");
        //setOverwriteDep('Yes'); 
        props.setLoadingBothAsIndAs(true);
        saveData('Yes');
    } else {
        // User clicked "Cancel"
        return false;
    }
  }
  const saveData = async (overwrite = 'No') => {
        const obj = {
            'owerwrite_dep': overwrite,
            'session': financeInfoBothAsIndAs.finance_year,
            'month': financeInfoBothAsIndAs.finance_month,
            'assets': listOptionsBothAsIndAs,
            'company_id': sessionStorage.getItem('LoggedInCompanyId'),
            'division_id': sessionStorage.getItem('LoggedInDivisionId'),
        };

        const EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

        const oData = { token: EncryptData };

        try {
            //setPopupLoadingBothAsIndAs('..'); // Start loading
            setValidName(false);
            const res = await calculateDepreciation(oData); // Wait for response
            const message = res?.data?.message || {};
            const tags = message?.tags || {};
            let msg = '';

                res.onmessage = (event) => {
                    const data = JSON.parse(event.data);
                    if (data.done) {
                        props.setLoadingBothAsIndAs(false);
                        res.close();
                    } else if (data.error) {
                        console.error("Error:", data.error);
                        props.setLoadingBothAsIndAs(false);
                        res.close();
                    } else {
                        props.setProgress(data.count);
                        props.setTotal(data.total);
                    }
                };
            //console.log(message.successBothAsIndAs);
            if (message.warning !== "") {
                if (Array.isArray(tags.pre_dep_tag) && tags.pre_dep_tag.length) {
                    msg += message.warning + ' Tags -: ' + tags.pre_dep_tag.join(', ');
                }
                if (Array.isArray(tags.owerwrite_tags) && tags.owerwrite_tags.length) {
                    msg += (msg ? ' | ' : '') + 'Overwrite Tags -: ' + tags.owerwrite_tags.join(', ');
                    setOverwriteBtnBothAsIndAs(true);
                }
                setErrMsgBothAsIndAs(msg);
                setSuccessBothAsIndAs('');
                
            }else if (message.successBothAsIndAs == 'Inserted') { console.log(tags);
                const allTags = tags.join(', '); console.log(allTags);
                setErrMsgBothAsIndAs('');
                setSuccessBothAsIndAs('Successfully Generated Depreciation. Data: ' + allTags);
                setOverwriteBtnBothAsIndAs(false);
            }else{
                //alert(message.successBothAsIndAs);
                setErrMsgBothAsIndAs(msg);
                setSuccessBothAsIndAs('Not process.');
            }
        } catch (err) {
            setSuccessBothAsIndAs(false);
            //console.error(err);
            if (!err?.data1) {
                setErrMsgBothAsIndAs('No Server Response');
            } else if (err.data1?.status === 409) {
                setErrMsgBothAsIndAs('Record already exists');
            } else {
                setErrMsgBothAsIndAs('Insert/Update Failed');
            }
            props.setLoadingBothAsIndAs(false);
        } finally {
            props.setLoadingBothAsIndAs(false); // Stop loading always
        }
    }
  const saveData_old = async (overwrite='No') => {
    var obj = {
      //'tag': tag, 
      'owerwrite_dep': overwrite, 
      'session':financeInfoBothAsIndAs.finance_year, 
      'month':financeInfoBothAsIndAs.finance_month,
      'assets':listOptionsBothAsIndAs,
      'company_id':sessionStorage.getItem('LoggedInCompanyId'),
      'division_id':sessionStorage.getItem('LoggedInDivisionId'),
    }
    
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data':obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData = {'token':EncryptData}
    try {  //setPopupLoadingBothAsIndAs('..'); // Set loading before sending API request
        calculateDepreciation(oData).then(function(res){
            //console.log(res);
            if(res.data.message.warning=="Already Exist"){
                setSuccessBothAsIndAs('');
                setErrMsgBothAsIndAs(' Depreciation Already Exist. Data: ' + res.data.message.tags.join(", ") );
                setOverwriteBtnBothAsIndAs(true);
            }else if(res.data.message.successBothAsIndAs=="Inserted"){
                setErrMsgBothAsIndAs('');
                setSuccessBothAsIndAs(' Successfully Genrated Depreciation. Data: '+ res.data.message.tags.join(", ") );
            }
            /*const message = res?.data?.message || {};
            const tags = message?.tags || {};
            let msg = '';
            //console.log(res);
            if(res.data.message.warning!=""){
                if (Array.isArray(tags.pre_dep_tag) && tags.pre_dep_tag.length) {
                    msg += message.warning + ' Tags -: ' + tags.pre_dep_tag.join(', ');
                }
                if (Array.isArray(tags.owerwrite_tags) && tags.owerwrite_tags.length) {
                    msg += (msg ? ' | ' : '') + 'Overwrite Tags -: ' + tags.owerwrite_tags.join(', ');
                }
                setErrMsgBothAsIndAs(msg);
                setSuccessBothAsIndAs('');
                setOverwriteBtnBothAsIndAs(true);
                
            }else if(res.data.message.successBothAsIndAs=="Inserted"){
                setErrMsgBothAsIndAs('');
                setSuccessBothAsIndAs(' Successfully Genrated Depreciation. Data: '+ res.data.message.tags.join(", ") );
            }*/
            //elementRef.current.focus();
        }); 
        setValidName(false);
        //setPopupLoadingBothAsIndAs(false); // Stop loading
    } catch (err) { setSuccessBothAsIndAs(false);
        //setPopupLoadingBothAsIndAs(false); // Stop loading
        if (!err?.data1) {
            //console.log(err);
            //setErrMsgBothAsIndAs('No Server Response');
            //setSuccessBothAsIndAs("Successfully saved Single Asset");
        } else if (err.data1?.status === 409) {
            //setErrMsgBothAsIndAs('Record already exist');
        } else {
            setErrMsgBothAsIndAs('Insert/Update Failed');
        }
        //elementRef.current.focus();
    }
  }

    const handleMoveList1 = (e) => {
        const selectedOptions =[];
        //alert('dd');
        var options1 = document.getElementById('lstBoxBoth').options;
        //console.log(options1);
        for (var i = 0, l = options1.length; i < l; i++) {
            if (options1[i].selected) {
                var option1 = {
                    label: options1[i].label,
                    value: options1[i].value,
                }
                if (pushListOptions(option1)) {
                    listOptionsBothAsIndAs.push(option1);
                }
            }
        } //setListData2(listOptionsBothAsIndAs); 
        setListDataBothAsIndAs((prevList) => prevList.filter((option) => !selectedOptions.find((selected) => selected.value === option.value)));
        
        //console.log('listOptionsBothAsIndAs');console.log(listOptionsBothAsIndAs);
    }
    const handleMoveList2 = (e) => {
        const selectedOptions2 =[];
        var options2 = document.getElementById('lstBox2').options;
        //console.log(options1);
        for (var i = 0, l = options2.length; i < l; i++) {
            if (options2[i].selected) {
                var option1 = {
                    label: options2[i].label,
                    value: options2[i].value,
                }
                if (pushListOptions(option1)) {
                    listOptionsBothAsIndAs.push(option1);
                }
            }
        } //setListData2(listOptionsBothAsIndAs); 
        setListDataBothAsIndAs((prevList) => prevList.filter((option) => !selectedOptions2.find((selected) => selected.value === option.value)));
        
        //console.log('listOptionsBothAsIndAs');console.log(listOptionsBothAsIndAs);
    }
    const handleAllMoveList1 = (e) => { //alert('dd');
        //var listOptions = [];
        var options1 = document.getElementById('lstBoxBoth').options;
        for (var i = 0, l = options1.length; i < l; i++) {
            var option1 = {
                label: options1[i].label,
                value: options1[i].value,
            }
            if (pushListOptions(option1)) {
                listOptionsBothAsIndAs.push(option1);
            }
            //listOptionsBothAsIndAs.push(option1);
        } //setListData2(listOptionsBothAsIndAs); console.log(listOptions2);
        setListDataBothAsIndAs(listOptionsBothAsIndAs);
    }
    const handleAllRemove = (e) => { //alert('dd');
        //var options2 = document.getElementById('lstBoxBoth').options;
        //alert(options.length);
        setListDataBothAsIndAs([]); 
    }
    
    return (
        <div className={block +" custom-modal width-80 height-80 relative"}>
        
        <div className="custom-close" > <span onClick={ ()=>{props.showsetterBothAsIndAs(false)} } className="bi bi-x-circle-fill"></span> </div>
            <div className="title custom-modal-title">
                <h5>{props.titleBothAsIndAs}</h5> 
                
            </div>
            {successBothAsIndAs ? (
				<div className="alert alert-successBothAsIndAs" role="alert"><i className="bi bi-check-circle-fill"></i>{successBothAsIndAs}</div>
			        ) : ( errMsgBothAsIndAs ? (<div className="alert alert-danger" role="alert"><i className="bi bi-exclamation-triangle-fill"></i>{errMsgBothAsIndAs}</div>):('')
                ) }
            <div className="subject-info-box-1">
            <input  type="search"  value={name} onChange={filter_both} className="form-control" placeholder="Filter"
            />
            <select multiple="multiple" id='lstBoxBoth' className="form-select form-select-sm">
            {foundAssetsBothAsIndAs && foundAssetsBothAsIndAs.length > 0 ? (
                foundAssetsBothAsIndAs.map((option) => (
                <option value={option.tag}>{option.tag}</option>
                ))
            ) : (
            <h1>No results</h1>
            )}
            </select>
        </div>

        <div className="subject-info-arrows text-center">{popupLoadingBothAsIndAs ? (<div className="spinner-border text-primary" role="status">
                              <span className="sr-only">{popupLoadingBothAsIndAs}</span>
                            </div>) : ('') }
        <button onClick={filter_both} value=""  className="btn btn-info btn-sm refresh">Refresh</button><br /><br />
        <input type='button' id='btnAllRight' onClick={handleAllMoveList1} value='Add All' className="btn btn-default" /><br />
        <input type='button' id='btnRight' onClick={handleMoveList1} value='>' className="btn btn-default" /><br />
        
        <input type='button' id='btnAllLeft' onClick={handleAllRemove} value='Remove All' className="btn btn-default" />
        </div>
    
        <div className="subject-info-box-2">
        {/*<div className="subject-refresh">
        <button onClick={refrest_ListData1} value=""  className="form-control btn-info refresh">Refresh</button>
            </div>*/}
        <select multiple="multiple" id='lstBox2' className="form-select form-select-sm">
            {   listOptionsBothAsIndAs.map((option) => (
                <option value={option.value}>{option.label}</option>
                )) }
        </select>
        </div>

        <div className="clearfix"></div>
        {(overwriteBtnBothAsIndAs)?(<form name="" onSubmit={handleOverwriteDep}>
            <button onClick={ () =>{ //data.push();
                                    props.datasetterBothAsIndAs(asset_data_both);
                                    }
                            } 
            className="btn btn-info btn-md float-end"> Overwrite </button>
            
        </form>):(<form name="" onSubmit={handleSubmit}>
            <button onClick={ () =>{ //data.push();
                                    props.datasetterBothAsIndAs(asset_data_both);
                                    }
                            } 
            className="btn btn-primary btn-md float-end"> Genrate </button>
            
        </form>)
        }
        
    </div>
    )
}

export default MultiListPopUpBothAsIndAs